export class DsoEvents {
// eslint-disable-next-line sonarjs/public-static-readonly
    static geometryClicked = "GeometryClicked";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static geometryNewCreated = "GeometryNewCreated";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static geometryModified = "geometryModified";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static geometriesDeleted = "geometriesDeleted";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringmoradeChanged = "destineringmoradeChanged";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradenDeleted = "destineringsomradenDeleted";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradenCancel = "destineringsomradenCancel";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradeFormStateChanged = "destineringsomradeFormStateChanged";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradenLoaded = "destineringsomradenLoaded";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradeAdded = "destineringsomradeAdded";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static destineringsomradePropertiesChanged = "destineringsomradePropertiesChanged";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static dsoSelected = "dsoSelected";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static dsoRemoveOutline = "dsoRemoveOutline";
}
